import { useEffect, useLayoutEffect, useState } from 'react';
/**
 * v3.9 hareket dili: kapanırken kısa çıkış animasyonu oynatabilmek için katmanı (dialog, sheet, menü) kapanış süresince
 * DOM'da tutar. Süre CSS değişkeninden okunur (`--cf-duration-panel` vb.); değişken yoksa (test ortamı) ya da kullanıcı
 * hareketi azaltmışsa (değişken 0ms) katman **aynı çizimde** kalkar — işlev ve test davranışı hareketten bağımsızdır.
 *
 * Kapanış sırasında katman etkileşim almamalıdır: çağıran `closing` iken `pointer-events-none` + `useInertWhile` uygular ve
 * modal davranışını HEMEN bırakır (odak tuzağı, sayfanın `inert`'i, odak iadesi kapanış başında; çıkış animasyonu
 * kullanıcının sonraki eylemini bekletmez).
 */
export function cssDurationMs(name) {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return 0;
    const raw = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (raw === '')
        return 0;
    const n = Number.parseFloat(raw);
    if (!Number.isFinite(n) || n <= 0)
        return 0;
    return raw.endsWith('ms') ? n : raw.endsWith('s') ? n * 1000 : n;
}
export function usePresence(open, durationVar = '--cf-duration-panel') {
    const [phase, setPhase] = useState(open ? 'open' : 'closed');
    // Çizim sırasında türetilen durum: açılış anında, kapanış süre 0 ise anında
    if (open && phase !== 'open')
        setPhase('open');
    if (!open && phase === 'open')
        setPhase(cssDurationMs(durationVar) > 0 ? 'closing' : 'closed');
    useEffect(() => {
        if (phase !== 'closing')
            return;
        const t = window.setTimeout(() => {
            setPhase('closed');
        }, cssDurationMs(durationVar));
        return () => {
            window.clearTimeout(t);
        };
    }, [phase, durationVar]);
    return { mounted: phase !== 'closed', closing: phase === 'closing' };
}
/**
 * Kapanan katmanı (çıkış animasyonu süresince) odak sırasından, tıklamadan ve erişilebilirlik ağacından birlikte çıkarır:
 * `inert`. `aria-hidden` yetmez — içinde odaklanabilir öğe bırakır (axe `aria-hidden-focus`, ciddi). React 18 türleri
 * `inert`i tanımadığından öznitelik çizimden hemen sonra (yerleşim efektinde) doğrudan yazılır; açılınca kaldırılır.
 */
export function useInertWhile(ref, active) {
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (active)
            el.setAttribute('inert', '');
        else
            el.removeAttribute('inert');
    }, [ref, active]);
}
//# sourceMappingURL=presence.js.map